import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { RequestStatus } from "../../utils/Enums";
import {
    deleteClientContact,
    getCurrentClientContact,
    resetDeleteClientContactStatus,
} from "../../store/reducers/ClientContactsSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import { LoggedInView } from "../common/LoggedInView";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";

interface DeleteClientContactScreenProps {}

export const DeleteClientContactScreen: React.FC<DeleteClientContactScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const clientContactsState = useAppSelector((state) => state.clientContacts);
    const requestStatus: RequestStatus = clientContactsState.deleteClientContactStatus;

    const { clientId, contactId } = useParams();

    // Check if contactId is defined and not empty before parsing
    const parsedClientId = clientId ? parseInt(clientId, 10) : undefined;
    const parsedContactId = contactId ? parseInt(contactId, 10) : undefined;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Kliendid", url: "/clients"},
        {text: "Kliendikontaktid", url: `/clients/${clientId}/contacts`},
        { text: "Kliendi kontakti kustutamine", url: `/clients/${clientId}/contacts/${contactId}/delete` },
    ];

    useEffect(() => {
        dispatch(resetDeleteClientContactStatus());
    }, [location]);

    const handleConfirm = () => {
        if (parsedClientId && parsedContactId ) {
            dispatch(deleteClientContact({ clientId: parsedClientId, contactId: parsedContactId }));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (parsedClientId && parsedContactId) {
            dispatch(getCurrentClientContact({ clientId: parsedClientId, contactId: parsedContactId }));
        }
    }, [parsedClientId, parsedContactId]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Kliendi kontakt kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{ textAlign: "center" }}>
                <div>
                    <h2>
                        Oled kindel, et soovid kliendi kontakti {' ' + clientContactsState?.currentClientContact?.name} kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes" />
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};